/// <amd-module name="Search/Package/Flux/Stores/NotificationStore" />

import * as VSSStore from "VSS/Reflux/Store";
import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub2";
import { PackageSearchRequest, PackageSearchResponseContent, PackageResult, InfoCodes } from "Search/WebApi/Contracts/Search.Shared";

export interface INotificationStoreState {
    indexingBannerState: IndexingBanner;
}

export enum IndexingBanner {
    AccountIndexing,

    None
}

export class NotificationStore extends VSSStore.Store {
    public state: INotificationStoreState;

    constructor(changedEventName: string) {
        super(changedEventName);
        this.state = this.getState();
    }

    public onSearchResultsLoaded = (payload: IResultsLoadedPayload<PackageSearchRequest, PackageSearchResponseContent, PackageResult>): void => {
        this.reset();
        const { response } = payload;
        if (response && response.infoCode === InfoCodes.AccountIsBeingReindexed) {
            this.state.indexingBannerState = IndexingBanner.AccountIndexing;
        }

        this.emitChanged();
    }

    private getState = (): INotificationStoreState => {
        return {
            indexingBannerState: IndexingBanner.None
        };
    }

    private reset = (): void => {
        this.state.indexingBannerState = IndexingBanner.None;
    }
}